import React, {useRef, useEffect, useState} from 'react'
import './StyleComponents/DigitalSATIntro.css'
import Contacts from './Components/Contacts'

export default function NewACTIntro(){
    const summaryRef = useRef()
    const digitalTestingRef = useRef()
    const oldVSNewRef = useRef()
    const quickComparisonRef = useRef()
    const adaptiveTestingRef = useRef()
    const paperlessRef = useRef()
    const scoringRef = useRef()
    const shortTestingRef = useRef()
    const surveyRef = useRef()
    const scienceRef = useRef()
    const satvsactRef = useRef()
    const finalRef = useRef()

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [expandedRows, setExpandedRows] = useState(new Set());
    const [hoveredRowIndex, setHoveredRowIndex] = useState(null);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
        }, []);

    const handleRowClick = (index) => {
        const newExpandedRows = new Set(expandedRows);
        if (newExpandedRows.has(index)) {
            newExpandedRows.delete(index);
        } else {
            newExpandedRows.add(index);
        }
        setExpandedRows(newExpandedRows);
    };

    const isExpanded = (index) => expandedRows.has(index);

    const getExpandIcon = (index) => (
        <svg
            className={`expand-icon-svg ${isExpanded(index) ? 'expanded' : ''}`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
        >
            <path d="M7.33 24l-2.83-2.829 9.339-9.175-9.339-9.167 2.83-2.829 12.17 12z" />
        </svg>
    );

    function scrollTo(to){
        var target = null;
        if (to === "Summary") target = summaryRef
        else if (to === "DigitalTesting") target = digitalTestingRef
        else if (to === "OldVSNew") target = oldVSNewRef
        else if (to === "QuickComparison") target = quickComparisonRef
        else if (to === "AdaptiveTesting") target = adaptiveTestingRef
        else if (to === "Paperless") target = paperlessRef
        else if (to === "ShortTesting") target = shortTestingRef
        else if (to === "Scoring") target = scoringRef
        else if (to === "Survey") target = surveyRef
        else if (to === "Science") target = scienceRef
        else if (to === "SATvsACT") target = satvsactRef
        else if (to === "Final") target = finalRef
        else target = summaryRef

        const position = target.current.getBoundingClientRect().top + window.pageYOffset - parseFloat(getComputedStyle(document.documentElement).fontSize)*2.5
        window.scrollTo({top: position, behavior: "smooth"})
    }

    useEffect(()=>{
        const options = {
          rootMargin: '0px',
          threshold: 0.3
        }
    
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('visible')
            }
          })
        }, options)
    
        const hiddenElements = document.querySelectorAll('.contacts-container')
        hiddenElements.forEach((element)=>observer.observe(element))
    
        return () => {
          observer.disconnect()
        }
    },[])

    return(
        <>
            <div className="main-side-wrapper">
                <div className="main-container">
                    <h1 class="page-title-underline">New Enhanced ACT!</h1>
                    <h3>The ACT has changed and here's what you need to know</h3>
                    <h2 ref={summaryRef}>Summary</h2>
                    <table className="act-table">
                    <thead className="act-table-header">
                        <tr>
                            <th>Feature</th>
                            <th>Old ACT</th>
                            <th>New ACT (Enhanced ACT)</th>
                        </tr>
                    </thead>
                        <tbody>
                            {/* Row 1 */}
                            <tr className={`act-table-row ${hoveredRowIndex === 0 ? 'hovered-group' : ''}`} 
                                onMouseEnter={() => setHoveredRowIndex(0)} 
                                onMouseLeave={() => setHoveredRowIndex(null)}
                                onClick={() => handleRowClick(0)}
                            >
                                <td className="act-table-cell">
                                    Delivery {getExpandIcon(0)}
                                </td>
                                <td className="act-table-cell">Paper-and-pencil only</td>
                                <td className="act-table-cell">Paper-and-pencil or online (at select centers)</td>
                            </tr>
                            <tr className={`expanded-row ${hoveredRowIndex === 0 ? 'hovered-group' : ''}`}
                                onMouseEnter={() => setHoveredRowIndex(0)} 
                                onMouseLeave={() => setHoveredRowIndex(null)}
                                onClick={() => handleRowClick(0)}
                            >
                                <td colSpan="3">
                                    <div className={`expandable-content ${isExpanded(0) ? 'expanded' : ''}`}>
                                        The Enhanced ACT offers a digital option, which can provide instant score reports for multiple-choice sections.
                                    </div>
                                </td>
                            </tr>

                            {/* Row 2 */}
                            <tr className={`act-table-row even-row ${hoveredRowIndex === 1 ? 'hovered-group' : ''}`}
                                onMouseEnter={() => setHoveredRowIndex(1)}
                                onMouseLeave={() => setHoveredRowIndex(null)}
                                onClick={() => handleRowClick(1)}
                            >
                                <td className="act-table-cell">
                                    Science Section {getExpandIcon(1)}
                                </td>
                                <td className="act-table-cell">Required for composite score</td>
                                <td className="act-table-cell">Optional; score is separate from composite</td>
                            </tr>
                            <tr className={`expanded-row even-row-detail ${hoveredRowIndex === 1 ? 'hovered-group' : ''}`}
                                onMouseEnter={() => setHoveredRowIndex(1)}
                                onMouseLeave={() => setHoveredRowIndex(null)}
                                onClick={() => handleRowClick(1)}
                            >
                                <td colSpan="3">
                                    <div className={`expandable-content ${isExpanded(1) ? 'expanded' : ''}`}>
                                        The Science section is now a standalone test. Its score does not affect your overall ACT Composite Score, allowing you to choose whether to take it based on your college application needs.
                                    </div>
                                </td>
                            </tr>
                            
                            {/* Row 3 */}
                            <tr className={`act-table-row ${hoveredRowIndex === 2 ? 'hovered-group' : ''}`}
                                onMouseEnter={() => setHoveredRowIndex(2)}
                                onMouseLeave={() => setHoveredRowIndex(null)}
                                onClick={() => handleRowClick(2)}
                            >
                                <td className="act-table-cell">
                                    Composite Score {getExpandIcon(2)}
                                </td>
                                <td className="act-table-cell">Average of four sections (English, Math, Reading, Science)</td>
                                <td className="act-table-cell">Average of three sections (English, Math, Reading)</td>
                            </tr>
                            <tr className={`expanded-row ${hoveredRowIndex === 2 ? 'hovered-group' : ''}`}
                                onMouseEnter={() => setHoveredRowIndex(2)}
                                onMouseLeave={() => setHoveredRowIndex(null)}
                                onClick={() => handleRowClick(2)}
                            >
                                <td colSpan="3">
                                    <div className={`expandable-content ${isExpanded(2) ? 'expanded' : ''}`}>
                                        Without the Science score factored in, the new Composite Score gives a more direct measure of your performance in the core academic areas of English, Math, and Reading.
                                    </div>
                                </td>
                            </tr>

                            {/* Row 4 */}
                            <tr className={`act-table-row even-row ${hoveredRowIndex === 3 ? 'hovered-group' : ''}`}
                                onMouseEnter={() => setHoveredRowIndex(3)}
                                onMouseLeave={() => setHoveredRowIndex(null)}
                                onClick={() => handleRowClick(3)}
                            >
                                <td className="act-table-cell">
                                    Total Test Time {getExpandIcon(3)}
                                </td>
                                <td className="act-table-cell">~2 hours, 55 minutes</td>
                                <td className="act-table-cell">~2 hours, 5 minutes (without Science)</td>
                            </tr>
                            <tr className={`expanded-row even-row-detail ${hoveredRowIndex === 3 ? 'hovered-group' : ''}`}
                                onMouseEnter={() => setHoveredRowIndex(3)}
                                onMouseLeave={() => setHoveredRowIndex(null)}
                                onClick={() => handleRowClick(3)}
                            >
                                <td colSpan="3">
                                    <div className={`expandable-content ${isExpanded(3) ? 'expanded' : ''}`}>
                                        The test is shorter if you opt out of the Science section, which can reduce test-taking fatigue.
                                    </div>
                                </td>
                            </tr>

                            {/* Row 5 */}
                            <tr className={`act-table-row ${hoveredRowIndex === 4 ? 'hovered-group' : ''}`}
                                onMouseEnter={() => setHoveredRowIndex(4)}
                                onMouseLeave={() => setHoveredRowIndex(null)}
                                onClick={() => handleRowClick(4)}
                            >
                                <td className="act-table-cell">
                                    Number of Questions {getExpandIcon(4)}
                                </td>
                                <td className="act-table-cell">215 (multiple-choice)</td>
                                <td className="act-table-cell">131 (without Science) or 171 (with Science)</td>
                            </tr>
                            <tr className={`expanded-row ${hoveredRowIndex === 4 ? 'hovered-group' : ''}`}
                                onMouseEnter={() => setHoveredRowIndex(4)}
                                onMouseLeave={() => setHoveredRowIndex(null)}
                                onClick={() => handleRowClick(4)}
                            >
                                <td colSpan="3">
                                    <div className={`expandable-content ${isExpanded(4) ? 'expanded' : ''}`}>
                                        Fewer questions in the core sections means less time spent per section.
                                    </div>
                                </td>
                            </tr>

                            {/* Row 6 */}
                            <tr className={`act-table-row even-row ${hoveredRowIndex === 5 ? 'hovered-group' : ''}`}
                                onMouseEnter={() => setHoveredRowIndex(5)}
                                onMouseLeave={() => setHoveredRowIndex(null)}
                                onClick={() => handleRowClick(5)}
                            >
                                <td className="act-table-cell">
                                    Math Answer Choices {getExpandIcon(5)}
                                </td>
                                <td className="act-table-cell">Five answer choices</td>
                                <td className="act-table-cell">Four answer choices</td>
                            </tr>
                            <tr className={`expanded-row even-row-detail ${hoveredRowIndex === 5 ? 'hovered-group' : ''}`}
                                onMouseEnter={() => setHoveredRowIndex(5)}
                                onMouseLeave={() => setHoveredRowIndex(null)}
                                onClick={() => handleRowClick(5)}
                            >
                                <td colSpan="3">
                                    <div className={`expandable-content ${isExpanded(5) ? 'expanded' : ''}`}>
                                        With only four answer choices, the probability of guessing the correct answer increases.
                                    </div>
                                </td>
                            </tr>

                            {/* Row 7 */}
                            <tr className={`act-table-row ${hoveredRowIndex === 6 ? 'hovered-group' : ''}`}
                                onMouseEnter={() => setHoveredRowIndex(6)}
                                onMouseLeave={() => setHoveredRowIndex(null)}
                                onClick={() => handleRowClick(6)}
                            >
                                <td className="act-table-cell">
                                    Test Questions {getExpandIcon(6)}
                                </td>
                                <td className="act-table-cell">All questions count; separate unscored experimental section</td>
                                <td className="act-table-cell">Unscored experimental questions are mixed in with scored questions</td>
                            </tr>
                            <tr className={`expanded-row ${hoveredRowIndex === 6 ? 'hovered-group' : ''}`}
                                onMouseEnter={() => setHoveredRowIndex(6)}
                                onMouseLeave={() => setHoveredRowIndex(null)}
                                onClick={() => handleRowClick(6)}
                            >
                                <td colSpan="3">
                                    <div className={`expandable-content ${isExpanded(6) ? 'expanded' : ''}`}>
                                        Experimental questions are now integrated seamlessly, making it more difficult to identify which questions are unscored.
                                    </div>
                                </td>
                            </tr>
                            
                            {/* Row 8 */}
                            <tr className={`act-table-row even-row ${hoveredRowIndex === 7 ? 'hovered-group' : ''}`}
                                onMouseEnter={() => setHoveredRowIndex(7)}
                                onMouseLeave={() => setHoveredRowIndex(null)}
                                onClick={() => handleRowClick(7)}
                            >
                                <td className="act-table-cell">
                                    Digital Features {getExpandIcon(7)}
                                </td>
                                <td className="act-table-cell">N/A</td>
                                <td className="act-table-cell">On-screen timer, highlighter, line reader, answer eliminator, etc.</td>
                            </tr>
                            <tr className={`expanded-row even-row-detail ${hoveredRowIndex === 7 ? 'hovered-group' : ''}`}
                                onMouseEnter={() => setHoveredRowIndex(7)}
                                onMouseLeave={() => setHoveredRowIndex(null)}
                                onClick={() => handleRowClick(7)}
                            >
                                <td colSpan="3">
                                    <div className={`expandable-content ${isExpanded(7) ? 'expanded' : ''}`}>
                                        The digital version includes a suite of tools designed to help test-takers manage their time and navigate the exam more efficiently.
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <h2 ref={shortTestingRef}>Shorter Test!</h2>
                    <p>One of the most significant changes to the Enhanced ACT is the shorter test. 
                        A common criticism directed towards ACT was testing fatigue and they have listened to that feedback. 
                        Here's a breakdown of how the exam has been trimmed down.
                        <table className="act-table">
                            <thead className="act-table-header">
                                <tr>
                                <th> </th>
                                <th>Old ACT</th>
                                <th>Enhanced ACT</th>
                                </tr>
                            </thead>
                            <tbody>
                                {/* Row 1 */}
                                <tr className={`act-table-row ${hoveredRowIndex === 0 ? 'hovered-group' : ''}`}
                                onMouseEnter={() => setHoveredRowIndex(0)}
                                onMouseLeave={() => setHoveredRowIndex(null)}
                                >
                                <td className="act-table-cell">English</td>
                                <td className="act-table-cell">{windowWidth < 900 ? "75Q - 45min." : "75 Questions - 45 Minutes"}</td>
                                <td className="act-table-cell">{windowWidth < 900 ? "50Q - 35min." : "50 Questions - 35 Minutes"}</td>
                                </tr>

                                {/* Row 2 */}
                                <tr className={`act-table-row even-row ${hoveredRowIndex === 1 ? 'hovered-group' : ''}`}
                                onMouseEnter={() => setHoveredRowIndex(1)}
                                onMouseLeave={() => setHoveredRowIndex(null)}
                                >
                                <td className="act-table-cell">Math</td>
                                <td className="act-table-cell">{windowWidth < 900 ? "60Q - 60min." : "60 Questions - 60 Minutes"}</td>
                                <td className="act-table-cell">{windowWidth < 900 ? "45Q - 50min." : "45 Questions - 50 Minutes"}</td>
                                </tr>
                                
                                {/* Row 3 */}
                                <tr className={`act-table-row ${hoveredRowIndex === 2 ? 'hovered-group' : ''}`}
                                onMouseEnter={() => setHoveredRowIndex(2)}
                                onMouseLeave={() => setHoveredRowIndex(null)}
                                >
                                <td className="act-table-cell">Reading</td>
                                <td className="act-table-cell">{windowWidth < 900 ? "40Q - 35min." : "40 Questions - 35 Minutes"}</td>
                                <td className="act-table-cell">{windowWidth < 900 ? "36Q - 40min." : "36 Questions - 40 Minutes"}</td>
                                </tr>

                                {/* Row 4 */}
                                <tr className={`act-table-row even-row ${hoveredRowIndex === 3 ? 'hovered-group' : ''}`}
                                onMouseEnter={() => setHoveredRowIndex(3)}
                                onMouseLeave={() => setHoveredRowIndex(null)}
                                >
                                <td className="act-table-cell">Science</td>
                                <td className="act-table-cell">{windowWidth < 900 ? "40Q - 35min." : "40 Questions - 35 Minutes"}</td>
                                <td className="act-table-cell">{windowWidth < 900 ? "40Q - 40min." : "40 Questions - 40 Minutes"}</td>
                                </tr>

                                {/* Row 5 */}
                                <tr className={`act-table-row ${hoveredRowIndex === 4 ? 'hovered-group' : ''}`}
                                onMouseEnter={() => setHoveredRowIndex(4)}
                                onMouseLeave={() => setHoveredRowIndex(null)}
                                >
                                <td className="act-table-cell">Total</td>
                                <td className="act-table-cell">{windowWidth < 900 ? "215Q - 2hr 55min" : "215 Questions - 2 Hrs 55 Min"}</td>
                                <td className="act-table-cell">
                                    {windowWidth < 900 ? 
                                    (<>w/o Science: 131Q - 2hr 5min <br/> w/ Science: 171Q - 2hr 45min</>) 
                                    : 
                                    (<>Without Science: 131 Questions - 2 Hrs 5 Mins <br/> With Science: 171 Questions - 2 Hrs 45 Mins</>)
                                    }
                                </td>
                                </tr>
                            </tbody>
                        </table>
                        <br/>
                        The test is now shorter in time regardless of whether you opt to take the Science section. 
                        Furthermore, the allotted time per question is seeing a 17% increase on average. 
                        The biggest increase is Reading with a 27% increase in time per question! 
                        Over the decades, the Reading and Science sections have been notorious for giving students a hard time. 
                        The sheer amount of required reading coupled with the very short time given made a grueling last 70 minutes of the exam. 
                        Incredibly, these changes to relax the time constraints did not come with any downsides! 
                        The exam's question quality and difficulty is going to remain relatively unchanged.
                        What this secretly means is that you can still practice the old paper exams of the past decades😉.
                    </p>
                    <h2 ref={digitalTestingRef}>Digital Testing</h2>
                    <p>The ACT is introducing online testing for the first time. 
                        However, students are still required to take the digital test at testing centers, so this is not to be confused with "remote" testing. 
                        Students will be permitted to bring their own computers, otherwise the student may request the testing center to provide a device. 
                        The enforce exam integrity, students are required to install a secure browser before taking the exam. 
                        Students may bring their own calculators <a href="https://www.act.org/content/act/en/products-and-services/the-act/test-day/calculator-policy.html">(click here for more information about which calculators are permitted for the ACT)</a> or use the built in calculator inside the secure browser. 
                        The secure browser also includes a suite of tools that students may benefit from: highlighter, question flagging, answer choice eliminators, automatic timer, question navigation, etc.

                    </p>
                    <h2 ref={scoringRef}>Scoring</h2>
                    <p>
                        The ACT's scoring is still scaled from 1 to 36. Your composite score is still the average of your subsections. 
                        If you choose not to take the Science section, then your composite score is simply the average of your English, Math, and Reading score. 
                        Here's an example: <br/><br/>
                        English: 32 <br/>
                        Math: 33 <br/>
                        Reading: 27 <br/>
                        Composite Score: (32+33+27)/3 = 30.66 &rarr; <b>31</b> <br/><br/>
                        Rounding your composite score can feel nice if it rounds up and can feel bad when it rounds down, but college admissions officers will pay more attention to your individual scores than your composite score. 
                        So, do your best on every section!
                    </p>
                    <h2 ref={surveyRef}>Survey Questions</h2>
                    <p>
                        In the past decade, ACT has been giving students a 5th section at random. These sections serve as data collection and feedback for the ACT. 
                        This data is used to calibrate the diffilculty of future exams. Many students, who know about the 5th section's insignificance to their test results, choose to not give ACT any data. 
                        To combat this, the Enhanced ACT now mixes survey questions in with the real questions. So, in a math section of 45 questions, maybe 3 of them are survey questions mixed in at random that will not be counted torwards your grade.
                        However, this also means that the exam is guaranteed to be the claimed 2 hours and 5 minutes, as there will not be an extra section to do (the extra section used to keep students for 30 more minutes)!
                    </p>
                    <h2 ref={scienceRef}>Should I Science?</h2>
                    <p>
                        The big question many students ask: Should I register to take the Science section? The answer depends completely on the context of the student's résumé. 
                        Key questions to ask yourself when considering whether to take the ACT with Science: <br/>
                        <ul>
                            <li>Are you planning to apply to colleges aiming for STEM programs?</li>
                            <li>Do you think you would do well on the Science section?</li>
                            <li>Do you have a strong STEM background on your existing résumé?</li>
                            <li>Are any of the universities you plan to apply to strongly recommend you or require you to take ACT Science?</li>
                        </ul>
                        If you answer yes to any of the questions above, it is strongly recommended that you take the ACT with Science. 
                        It is also extrmely important to note that the ACT Science does <u>NOT</u> test you on your science knowledge. 
                        ACT Science tests you on your ability to think in a scientific way and your ability to extrapolate information from given data. 
                        Even if you are not a STEM person, if you can do well on the ACT Science, it can only benefit your overall high school résumé. 
                    </p>
                    <h2 ref={satvsactRef}>ACT or SAT?</h2>
                    <p>
                        <table className="act-table">
                            <thead className="act-table-header">
                                <tr>
                                    <th> </th>
                                    <th>Digital SAT</th>
                                    <th>Enhanced ACT</th>
                                </tr>
                            </thead>
                            <tbody>
                                {/* Row 1: Testing Mode */}
                                <tr className={`act-table-row ${hoveredRowIndex === 0 ? 'hovered-group' : ''}`}
                                onMouseEnter={() => setHoveredRowIndex(0)}
                                onMouseLeave={() => setHoveredRowIndex(null)}
                                >
                                    <td className="act-table-cell">Testing Mode</td>
                                    <td className="sat-table-cell">Digital, Adaptive</td>
                                    <td className="act-enhanced-table-cell">Digital or Paper-Based</td>
                                </tr>

                                {/* Row 2: Structure/Sections */}
                                <tr className={`act-table-row even-row ${hoveredRowIndex === 1 ? 'hovered-group' : ''}`}
                                onMouseEnter={() => setHoveredRowIndex(1)}
                                onMouseLeave={() => setHoveredRowIndex(null)}
                                >
                                    <td className="act-table-cell">Sections</td>
                                    <td className="sat-table-cell">2 Modules: Reading/Writing & Math</td>
                                    <td className="act-enhanced-table-cell">3 Sections (+ Optional Science): English, Math, Reading</td>
                                </tr>
                                
                                {/* Row 3: Total Time */}
                                <tr className={`act-table-row ${hoveredRowIndex === 2 ? 'hovered-group' : ''}`}
                                onMouseEnter={() => setHoveredRowIndex(2)}
                                onMouseLeave={() => setHoveredRowIndex(null)}
                                >
                                    <td className="act-table-cell">Total Time</td>
                                    <td className="sat-table-cell">{windowWidth < 900 ? "2hr 14min" : "2 Hours 14 Minutes"}</td>
                                    <td className="act-enhanced-table-cell">{windowWidth < 900 ? "2hr 5min" : "2 Hours 5 Minutes"}</td>
                                </tr>

                                {/* Row 4: Total Questions (Approx) */}
                                <tr className={`act-table-row even-row ${hoveredRowIndex === 3 ? 'hovered-group' : ''}`}
                                onMouseEnter={() => setHoveredRowIndex(3)}
                                onMouseLeave={() => setHoveredRowIndex(null)}
                                >
                                    <td className="act-table-cell">Total Questions</td>
                                    <td className="sat-table-cell">98</td>
                                    <td className="act-enhanced-table-cell">131 (w/o Science)</td>
                                </tr>
                                
                                {/* Row 5: Question Style/Focus (NEW) */}
                                <tr className={`act-table-row ${hoveredRowIndex === 4 ? 'hovered-group' : ''}`}
                                onMouseEnter={() => setHoveredRowIndex(4)}
                                onMouseLeave={() => setHoveredRowIndex(null)}
                                >
                                    <td className="act-table-cell">Question Style/Focus</td>
                                    <td className="sat-table-cell">Focused on critical reasoning & evidence</td>
                                    <td className="act-enhanced-table-cell">Straightforward, content-based testing</td>
                                </tr>


                                {/* Row 6: Scoring Range (Updated to 'even-row') */}
                                <tr className={`act-table-row even-row ${hoveredRowIndex === 5 ? 'hovered-group' : ''}`}
                                onMouseEnter={() => setHoveredRowIndex(5)}
                                onMouseLeave={() => setHoveredRowIndex(null)}
                                >
                                    <td className="act-table-cell">Score Range</td>
                                    <td className="sat-table-cell">400~1600</td>
                                    <td className="act-enhanced-table-cell">1~36</td>
                                </tr>
                            </tbody>
                        </table> <br/>
                        Although the SAT has made a shift to Digital Testing and introduced Adaptive Testing, the ACT is <u>NOT</u> introducing Adapting Testing despite its push to administer Digital Testing. 
                        Furthermore, ACT is still offering paper testing for those who perform better when not looking at a monitor. <br/><br/>
                        It has been a long standing tradition that the SAT focuses more on critical reasoning skills while the ACT focuses more on expansive knowledge + scientific reasoning. 
                        Even after the changes to both the SAT and the ACT, this tradition is still persisting. Another long standing tradition is the laxed time constraints of the SAT compared to the time crunch of the ACT. <br/><br/>
                        So, should you take the SAT or the ACT? Unfortuntely, there is no right answer. We, Tenafly Prep Academy, strongly recommend students to try both before they decide to dive into deeper studies for one of the two. 
                        Many students find one exam easier than the other. Some students find it easier to improve their scores for one over the other. Students just need to be open minded to their opportunities. 
                    </p>
                    <h2 ref={finalRef}>Final Thoughts</h2>
                    <p>
                        The Enhanced ACT is great progress in test taking, allowing flexible test taking opportunities and pushing for shorter tests. 
                        We think that the ACT has always been writing better question quality than the SAT and it will remain the same. 
                        ACT has also demonstrated its commitment to delivering a quality test by addressing its main criticisms, for example, test length, too little time, and science requirement. <br/><br/>
                        Regardless if you are already studying for the SAT, give the ACT a try and you might be surprised. We, at Tenafly Prep Academy, offer practice ACT tests (currently paper only) and score tracking on student/parent portals. 
                        Our contact information is directly below &darr;
                    </p>
                </div>
                <div className="side-container">
                    <div className="sticky-container">
                        <h3>Table of Contents</h3>
                        <div className="sidebar-button-container">
                            <ul style={{listStyle:"none", paddingLeft:"2rem"}}>
                                <li><button onClick={()=>scrollTo("Summary")} className="sidebar-button">Summary</button></li>
                                <li><button onClick={()=>scrollTo("ShortTesting")} className="sidebar-button">Shorter Test</button></li>
                                <li><button onClick={()=>scrollTo("DigitalTesting")} className="sidebar-button">Digital Testing</button></li>
                                <li><button onClick={()=>scrollTo("Scoring")} className="sidebar-button">Scoring</button></li>
                                <li><button onClick={()=>scrollTo("Survey")} className="sidebar-button">Survey Questions</button></li>
                                <li><button onClick={()=>scrollTo("Science")} className="sidebar-button">Science?</button></li>
                                <li><button onClick={()=>scrollTo("SATvsACT")} className="sidebar-button">SAT vs ACT</button></li>
                                <li><button onClick={()=>scrollTo("Final")} className="sidebar-button">Final Thoughts</button></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <Contacts/>
        </>
    )
}